const SubscriptionTagBlock = ({ productData, product }) => {
  if (!productData) return;

  const idx = productData?.subscription.products?.findIndex((p) => p.amount === String(product.amount)) || 0;

  const subscriptionTemplate = window.subscription_template;
  const rawOverview = subscriptionTemplate.tr_subscription_overview;

  let message = rawOverview.replace("###react_qty###", product.amount);

  const needsDuration = rawOverview.includes("###react_duration###");
  const durations = subscriptionTemplate.receive_duration?.split(",") || [];
  const duration = durations[idx];

  if (needsDuration && duration) {
    message = message.replace("###react_duration###", duration);
  }

  // dont show if required field is missing
  if (needsDuration && !duration) return;

  return <p className="productCard__titleBlock__subscriptionTagBlock">{message}</p>;
};

export default SubscriptionTagBlock;
